import React from 'react'
import styled from '@emotion/styled'

import { FlexRowDiv } from '../generic/Basics'
import TradeIn from './steps/TradeIn'
import Sell from './steps/Sell'
import Shop from './steps/Shop'

const steps = [
  { number: 1, header: 'Start the Trade In Process Online', subheader: 'We can connect you with a local dealership about your car - and a no-obligation quote for your next one.' },
  { number: 2, header: 'Sell Your Car Yourself', subheader: 'Reach serious shoppers on Autotrader and KBB.com - for one low price.' },
  { number: 3, header: 'Shop for Your Next Car', subheader: 'See trusted pricing, get reviews and find the car in stock near you.' }
]
export default ({ kbbUrl, atcUrl, year, make, model, trim }) => (
  <MainStepDiv>
    <TradeIn header={steps[0].header} subheader={steps[0].subheader} year={year && year.displayName} make={make && make.displayName} model={model && model.displayName} trim={trim && trim.displayName} kbbUrl={kbbUrl} />
    <SecondaryStepDiv>
      <Sell header={steps[1].header} subheader={steps[1].subheader} atcUrl={atcUrl} />
      <Shop header={steps[2].header} subheader={steps[2].subheader} kbbUrl={kbbUrl} />
    </SecondaryStepDiv>
  </MainStepDiv>
)
const SecondaryStepDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`
const MainStepDiv = styled(FlexRowDiv)`
  flex-wrap: wrap;
  justify-content: space-evenly;
`
